import { Box, Button, Grid, Group, Text } from '@mantine/core'
import { IconDeviceFloppy } from '@tabler/icons-react'
import { clsx } from 'clsx'
import { useCallback } from 'react'

import { MarkdownEditor } from '@/components/MarkdownEditor'
import { useGlobalState } from '@/hooks/useGlobalState'
import type { CMFormSection } from '@/screens/ContentModuleFormScreen/ContentModuleFormScreen'
import * as commonClasses from '@/styles/componentCommons.css'

export function AddStepDataContentModal(props: CMFormSection) {
  const { uiStore } = useGlobalState()

  // Use form as single source of truth for content
  const initialContent = props.stepForm.getValues().content.text || props.stepContentQuery.data?.content || ''

  const handleContentChange = useCallback(
    (markdown: string) => {
      props.stepForm.setFieldValue('content.text', markdown)
    },
    [props.stepForm],
  )

  async function createCM() {
    const validation = props.stepForm.validateField('content.text')

    if (validation.hasError) {
      return
    }

    // Get content directly from form state
    const markdownContent = props.stepForm.getValues().content.text

    if (props.stepId) {
      await props.contentUpdateMutation?.mutateAsync({
        step_id: props.stepId,
        text: markdownContent,
      })
    } else {
      const lastStep = props.stepsQuery.data?.[props.stepsQuery.data.length - 1]

      const result = await props.stepCreateMutation.mutateAsync({
        task_id: props.taskId!,
        preceding_step_id: lastStep?.stepId,
        content: markdownContent,
      })

      if (result.stepId) {
        uiStore.setPendingStepDeletion(true)
      }
    }

    props.closeModal()
  }

  const isMutating = props.stepCreateMutation?.isPending || props.contentUpdateMutation?.isPending
  const hasError = !!props.stepForm.getInputProps('content.text').error

  return (
    <>
      <Group gap="lg" justify="flex-end" style={{ position: 'absolute', top: 20, right: 20, zIndex: 1000 }}>
        <Button variant="light" color="gray" onClick={() => props.closeModal()} disabled={isMutating}>
          Cancel
        </Button>
        <Button leftSection={<IconDeviceFloppy />} onClick={createCM} loading={isMutating} disabled={hasError}>
          Save Content
        </Button>
      </Group>

      <Box className={commonClasses.stickyModalFooterContentWrapper}>
        <Grid gutter="xxxl">
          <Grid.Col span={12}>
            <MarkdownEditor
              defaultValue={initialContent}
              onChange={handleContentChange}
              readOnly={isMutating}
              className={clsx(isMutating && 'opacity-60 pointer-events-none')}
              style={{
                minHeight: '50vh',
              }}
            />
            {props.stepForm.getInputProps('content.text').error && (
              <Text size="md" c="red" my={8}>
                {props.stepForm.getInputProps('content.text').error}
              </Text>
            )}
          </Grid.Col>
        </Grid>
      </Box>
    </>
  )
}
